module.exports = __webpack_public_path__ + "static/img/15.7321dbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/15.png
// module id = c4BD
// module chunks = 0